import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="submit-form"
export default class extends Controller {
  static targets = ["form"]

  submit() {
    this.formTarget.submit()
  }
}
